var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26.818v14.364a.807.807 0 0 1-.976.798C2.678 15.166 0 11.9 0 8 0 4.1 2.678.834 6.284.02a.798.798 0 0 1 .899.446.82.82 0 0 1 .077.352Zm1.638 0v5.545c0 .448.363.815.807.815h5.477c.516 0 .903-.48.79-.994C15.287 3.122 12.908.712 9.883.02a.81.81 0 0 0-.984.798Zm0 8.819v5.545a.81.81 0 0 0 .984.798c3.033-.692 5.413-3.11 6.099-6.172a.821.821 0 0 0-.791-.994H9.713a.827.827 0 0 0-.815.823Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsSolid);
export default __webpack_public_path__ + "static/media/statistics-solid.cfe9e89f66c176ff35e61d3a557d4195.svg";
export { ForwardRef as ReactComponent };